import { Check } from './icons/Check'

const checkItems = [
  'Companies House check',
  'Bankruptcy check',
  'Legal Aid Agency check',
  'Legal Regulator check',
  'Prohibition check',
]

const Checks = () => {
  return (
    <section id='checks' className='flex justify-center'>
      <div className='inline-flex flex-col justify-start items-center gap-3 mt-12 px-4'>
        <div className="text-center text-slate-700 text-xs sm:text-sm font-normal font-['DM_Sans'] leading-tight tracking-wide">
          All the profiles on our site are verified by us. These are the checks
          we do.
        </div>
        <div className='flex flex-wrap justify-center gap-4 text-xs sm:text-base'>
          {checkItems.map((label) => (
            <div
              key={label}
              className='flex items-center bg-white rounded-xl outline outline-[0.60px] outline-offset-[-0.60px] outline-blue-200 p-3 gap-3 min-w-[160px] max-w-xs'
            >
              <div className='flex-shrink-0'>
                <Check />
              </div>
              <div className="text-slate-500 text-xs font-medium font-['DM_Sans'] leading-snug tracking-wide break-words">
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Checks
